module.exports = __webpack_public_path__ + "img/frame-black.378d2ce.webp";